export default "__VITE_ASSET__dVq7I1Bi__"